import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import Dialog from '@material-ui/core/Dialog';

import TextField from '@material-ui/core/TextField';
import { Autocomplete, Alert, AlertTitle } from '@material-ui/lab';

import { updateCustomerUser } from '../../../redux/tracking-manager';

import Toggle from '../../../components/Toggle';

import { S } from './styles';
import Mask from '../../../utils/Mask';
import { ListCompanies } from '../RegisterModal/styles';
import { cpfOrCnpjMask } from '../../Tracking/components/NFFilters/masks';

const EditModal = ({
  open,
  onClose,
  dispatch,
  companiesList,
  companiesFetching,
  currentUser,
  customerUser,
  onSubmit,
}) => {
  const [id, setId] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [company, setCompany] = useState('');
  const [formDisabled, setFormDisabled] = useState(true);
  const [trackingActive, setTrackingActive] = useState(true);

  useEffect(() => {
    setId(currentUser.Id);
    setName(currentUser.Name);
    setEmail(currentUser.Email);
    setPhone(currentUser.Phone);
    
    const customer = companiesList.find(item =>
      item.ds_RazaoSocial === currentUser.ds_RazaoSocial
    );
    
    if (customer) {
      setCompany(customer);
    } else {
      setCompany(currentUser.ds_RazaoSocial);
    }

    setTrackingActive(currentUser.HasTracking);

  }, [currentUser]);

  useEffect(() => {
    if (name !== '' && email !== '' && company !== '') {
      setFormDisabled(false);
    } else {
      setFormDisabled(true);
    }
  }, [name, email]);

  const handleSubmit = () => {
    if ((name, email)) {
      dispatch(updateCustomerUser({
        id,
        name,
        email,
        phone,
        trackingActive,
        taxNumber: company.cd_CGCCPF,
      }));

      onSubmit();
    }
  };

  const filterOptions = (options, { inputValue }) => {
    if (inputValue.trim() !== '') {
      const companyName = options.filter((option) => 
        option.ds_RazaoSocial.includes(inputValue.trim().toUpperCase())     
      )
      const taxNumber = options.filter((option) => 
        option.cd_CGCCPF.includes(Mask.numbers(inputValue.trim()))
      )

      return companyName.length > 0 ? companyName : taxNumber;
    } 
    return options;
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: { borderRadius: 0 },
      }}
    >
      <S.ModalContainer>
        <S.ModalHeader>
          <S.ModalTitle>Editar novo contato</S.ModalTitle>
          <S.CloseButton name="close" onClick={onClose} />
        </S.ModalHeader>
        <S.ModalContent>
          <S.Form>
            <TextField
              placeholder="Nome*"
              value={name}
              onChange={e => {
                const value = e.target.value.replace(/[0-9]/g, "");
                setName(value);
              }}
              fullWidth
              required
            />

            <TextField
              placeholder="E-mail*"
              fullWidth
              value={email}
              onChange={e => setEmail(e.target.value)}
              style={{ marginTop: '48px' }}
              required
            />

            <TextField
              placeholder="Telefone"
              value={phone}
              onChange={e => setPhone(e.target.value)}
              style={{ marginTop: '48px' }}
              fullWidth
            />

            <Autocomplete
              id="company"
              options={companiesList}
              getOptionLabel={option => option.ds_RazaoSocial}
              defaultValue={{ ds_RazaoSocial: currentUser.ds_RazaoSocial }}
              loading={companiesFetching}
              filterOptions={filterOptions}
              onChange={(_, value) => setCompany(value)}
              style={{ marginTop: '38px' }}
              renderInput={params => (
                <TextField {...params} fullWidth label="Nome da empresa ou CNPJ*" />
              )}
              renderOption={(props) => {
                return (
                  <ListCompanies>
                    <h4>
                      {props.ds_RazaoSocial}
                    </h4>
                    <span>
                      {cpfOrCnpjMask(props.cd_CGCCPF)}
                    </span>
                  </ListCompanies>
                )
              }}
              required
            />

            <S.TrackingActiveContainer>
              <S.TrackingActive>Ativar/desativar rastreio</S.TrackingActive>
              <S.ToggleContainer>
                <Toggle
                  isChecked={trackingActive}
                  onChange={() => setTrackingActive(!trackingActive)}
                  label={null}
                  icon={null}
                  small
                />
                <S.CheckBoxLabel checked={trackingActive}>
                  Rastreio ativo
                </S.CheckBoxLabel>
              </S.ToggleContainer>
              <S.TrackingDisclaimer>
                Ao ser aprovado, seu destinatário estará com o rastreio ativado.
              </S.TrackingDisclaimer>
            </S.TrackingActiveContainer>
            {customerUser.error && customerUser.error !== '' && (
              <S.WrapperAlert>
                <Alert severity="error">
                  <AlertTitle>Erro ao cadastrar</AlertTitle>
                  {customerUser.error}
                </Alert>
              </S.WrapperAlert>
            )}
          </S.Form>
        </S.ModalContent>
        <S.ModalFooter>
          <S.StyledButton onClick={onClose}>Cancelar</S.StyledButton>
          <S.StyledButton skin="primary" onClick={handleSubmit} disabled={formDisabled}>
            Salvar
          </S.StyledButton>
        </S.ModalFooter>
      </S.ModalContainer>
    </Dialog>
  );
};

function mapStateToProps(state) {
  return {
    customerUser: state.trackingManager.customerUser,
  };
}

export default connect(mapStateToProps)(EditModal);
